module.exports = global["jQuery"] = require("-!.\\jquery.js");


//////////////////
// WEBPACK FOOTER
// ../node_modules/jquery/dist/jquery.js-exposed
// module id = 0
// module chunks = 0